import React from 'react';
import PropTypes from 'prop-types';

import CustomerInfoSection from './CustomerInfoSection';

export default class InsuredChildren extends React.Component {
    static propTypes = {
        modifierClass: PropTypes.array,
        title: PropTypes.string,
        description: PropTypes.string,
        onAddButtonClick: PropTypes.func,
        addButtonUrl: PropTypes.string,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ]),
    }

    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        signupUrl: '',
        children: [],
        onAddButtonClick: () => {}
    };

    render() {
        return (
            <CustomerInfoSection
                title={this.props.title}
                description={this.props.description}
                showAddButton={true}
                addButtonLabel={"Teckna ytterligare försäkring"}
                onAddButtonClick={this.props.onAddButtonClick}
                addButtonUrl={this.props.addButtonUrl}
            >
                <div>
                    {this.props.children}
                </div>
            </CustomerInfoSection>
        );
    }
};
